const secretsData = {
  cookie: 'GMM_data_access',
  encryt: 'GMM_access_token',
};

export default secretsData;
